import mistletoeBall from "../../images/holidayIcons/mistletoeBall.png";
import cleaningSnow from "../../images/holidayIcons/cleaningSnow.png";
import eggnog from "../../images/holidayIcons/eggnog.png";
import house from "../../images/holidayIcons/house.png";
import poinsettia from "../../images/holidayIcons/poinsettia.png";
import bticoin from "../../images/holidayIcons/bticoin.png";
import stockings from "../../images/holidayIcons/stockings.png";
import swiss from "../../images/holidayIcons/swiss .png";
import uglySweater from "../../images/holidayIcons/uglySweater.png";
import wrappingPaper from "../../images/holidayIcons/wrappingPaper.png";

const questions = [
  {
    id: 1,
    title: "Poinsettia",
    desc: "You purchase five California-grown Poinsettias to decorate your house for the holidays.",
    answer: "yes",
    icon: poinsettia,
    wrongAnswerText:
      "Not quite! The poinsettias are grown in California, so they count towards U.S. GDP.",
    rightAnswerText:
      "Great job! The poinsettias are grown in California, so they count towards U.S. GDP.",
  },
  {
    id: 2,
    title: "Ingredients for a Gingerbread house",
    desc: "You purchase locally-sourced ingredients to make a gingerbread house with your siblings.",
    answer: "yes",
    icon: house,
    wrongAnswerText:
      "Not quite! Because the gingerbread house will not be sold, the ingredients for it are considered final goods, so they count towards U.S. GDP.",
    rightAnswerText:
      "Great job! Because the gingerbread house will not be sold, the ingredients for it are considered final goods, so they count towards U.S. GDP.",
  },
  {
    id: 3,
    title: "Swiss hot chocolate",
    desc: "While visiting Switzerland, you buy your mom a package of Swiss hot chocolate to surprise her when you go back to the U.S. for the holidays.",
    answer: "no",
    icon: swiss,
    wrongAnswerText:
      "Not quite! Since the hot chocolate was produced in Switzerland, it does not count towards U.S. GDP.",
    rightAnswerText:
      "Great job! Since the hot chocolate was produced in Switzerland, it does not count towards U.S. GDP.",
  },
  {
    id: 4,
    title: "Ugly sweater",
    desc: "You sell your sister's ugly sweater online, since it doesn't fit her anymore.",
    answer: "no",
    icon: uglySweater,
    wrongAnswerText: "Not quite! Used goods do not count towards U.S. GDP.",
    rightAnswerText: "Great job! Used goods do not count towards U.S. GDP.",
  },
  {
    id: 5,
    title: "Bitcoin",
    desc: "Bitcoin becomes the go-to holiday gift this year, and the price increases to $100,000.",
    answer: "no",
    icon: bticoin,
    wrongAnswerText:
      "Not quite! GDP measures the market value of current production and does not include asset price such as stock prices or Bitcoin price, so an increase in the price of Bitcoin does not count towards U.S. GDP.",
    rightAnswerText:
      "Great job! GDP measures the market value of current production and does not include asset price such as stock prices or Bitcoin price, so an increase in the price of Bitcoin does not count towards U.S. GDP.",
  },
  {
    id: 6,
    title: "Mistletoe ball",
    desc: "The city of Houston buys a huge U.S.-made mistletoe ball to put in a park for the holidays this year.",
    answer: "yes",
    icon: mistletoeBall,
    wrongAnswerText:
      "Not quite! The mistletoe ball is a final good produced in the U.S., and government purchases count towards U.S. GDP.",
    rightAnswerText:
      "Great job! The mistletoe ball is a final good produced in the U.S., and government purchases count towards U.S. GDP.",
  },
  {
    id: 7,
    title: "Custom face photo wrapping paper",
    desc: "You order custom face photo wrapping paper from a local company to wrap Hanukkah presents for your relatives.",
    answer: "yes",
    icon: wrappingPaper,
    wrongAnswerText:
      "Not quite! You will use the wrapping paper to wrap presents, but won't resell this paper. Therefore, the wrapping paper counts towards U.S. GDP.",
    rightAnswerText:
      "Great job! You will use the wrapping paper to wrap presents, but won't resell this paper. Therefore, the wrapping paper counts towards U.S. GDP.",
  },
  {
    id: 8,
    title: "Christmas stockings",
    desc: "You use fabric you found in your grandparents' house to sew Christmas stockings for you and your little brother.",
    answer: "no",
    icon: stockings,
    wrongAnswerText:
      "Not quite! If you had bought U.S.-made stockings, they would count towards U.S. GDP. However, because you made them at home, they do not count towards U.S. GDP.",
    rightAnswerText:
      "Great job! If you had bought U.S.-made stockings, they would count towards U.S. GDP. However, because you made them at home, they do not count towards U.S. GDP.",
  },
  {
    id: 9,
    title: "Eggnog",
    desc: "You buy your parents' favorite kind of eggnog for the holidays, which is made in Philadelphia, PA.",
    answer: "yes",
    icon: eggnog,
    wrongAnswerText:
      "Not quite! The Philadelphia-made eggnog is a finished good produced in the U.S. this year, so it counts towards U.S. GDP.",
    rightAnswerText:
      "Great job! The Philadelphia-made eggnog is a finished good produced in the U.S. this year, so it counts towards U.S. GDP.",
  },
  {
    id: 10,
    title: "Cleaning snow",
    desc: "You remove the snow in your neighbor's yard and he pays you $20",
    answer: "no",
    icon: cleaningSnow,
    wrongAnswerText:
      "Not quite! This service is not part of the formal economy. The Bureau of Labor Statistics is not able to count this type of work, so it does not count towards U.S. GDP.",
    rightAnswerText:
      "Great job! This service is not part of the formal economy. The Bureau of Labor Statistics is not able to count this type of work, so it does not count towards U.S. GDP.",
  },
];

export default questions;
